// This function is used to provide error messages to the user that are
// different than the error messages provided by the SDK. The SDK message
// itself always arrives in English; only the appended hint is translated.
type TranslateFn = (key: string) => string;

export default function enhanceMessage(message = '', code?: number, t?: TranslateFn) {
  switch (code) {
    case 20101: // Invalid token error
      return t ? `${message}. ${t('twilio-invalid-token-hint')}` : message;
    case 53000: // Signaling connection error
    case 53001: // Signaling connection disconnected
    case 53002: // Signaling connection timed out
    case 53405: // Media connection failed or media activity ceased
      // Media/signaling path blocked — almost always a firewall/proxy on the
      // user's network (common in clinics), not an application problem.
      return t ? `${message}. ${t('twilio-network-blocked-hint')}` : message;
    default:
      return message;
  }
}
